import { redirect } from "react-router-dom";
import { getSignupStep } from "@/entities/auth/signup/api/requests";

export const authLoader = async (): Promise<string | Response> => {
  const token = localStorage.getItem("token");

  if (token) {
    const response = await getSignupStep(token);
    const step = response?.step;

    if (step === null) {
      return redirect("/cabinet", { status: 301 });
    }

    if (typeof step === "number") {
      return redirect("/signup", { status: 301 });
    }

    return "";
  }
  return "";
};
